import { z } from "zod";

/** Selects the tenant for users who belong to more than one (ARCHITECTURE.md 5). */
export const HEADER_TENANT = "X-Tenant";

/** Honored on every POST that creates or changes bookings, payments, messages, provisioning. */
export const HEADER_IDEMPOTENCY = "Idempotency-Key";

/** Set on replayed idempotent responses. */
export const HEADER_IDEMPOTENT_REPLAYED = "Idempotent-Replayed";

export const HEADER_REQUEST_ID = "X-Request-Id";

/** Cloudflare Access injects this on requests to the admin hostname. */
export const HEADER_ACCESS_JWT = "Cf-Access-Jwt-Assertion";

/** Internal: the API forwards a serialized Actor to the tenant object on WebSocket upgrades. */
export const HEADER_ACTOR = "X-Actor";

export const idempotencyKeySchema = z
  .string()
  .min(8, "Idempotency-Key must be at least 8 characters")
  .max(128)
  .regex(/^[A-Za-z0-9_\-:.]+$/, "Idempotency-Key may contain letters, digits, - _ : .");
